export default class Group {
  static async retrieve(axios, id) {
    const response = await axios.post('/graphql/', {
        query: `query groupRetrieve($id: ID!) {
        groupRetrieve(id: $id) {
          id
          name
          permissions{
            id
            name
          } 
        }
      }`,
        variables: {
          "id": id
        }
      },
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );

    return response.data.data.groupRetrieve;
  }

  static async all(axios) {
    const response = await axios.post(
      '/graphql/',
      `query{
        groupList {
            id
            name
            permissions{
              id
              name
            }
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.groupList.reverse();
  }

  static async delete(axios, id) {
    const response = await axios.post(
      '/graphql/', {
        query: `mutation deleteGroup ($id: ID!){
          deleteGroup(id: $id){
            ok
          }
        }`,
        variables: {
          "id": id
        }
      },
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );

    return response.data.data.deleteGroup.ok;
  }

  static async create(axios, name, permissions) {
    const response = await axios.post(
      '/graphql/',
      `mutation{
        createGroup (newGroup: {
            name: "${name}", 
            permissions: ${permissions} 
        }) {
          ok
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.createGroup.ok;
  }

  static async edit(axios, id, name, permissions) {
    const response = await axios.post(
      '/graphql/',
      `mutation{
        updateGroup (newGroup: {
            id: "${id}", 
            name: "${name}", 
            permissions: ${permissions} 
        }) {
          ok
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.updateGroup.ok;
  }


}
